<template>
  <v-card class="pa-2">
    <v-card-title>{{data.title}}</v-card-title>
    <v-card-text class="body-1">
      <template v-for="(item,index) in data.items">
        <div class="mb-2 pa-3 grey lighten-5" :key="index">
          <div
            class="body font-weight-bold"
            v-if="item.title.length > 0"
          >{{(index + 1) + ". " + item.title}}</div>
          <div class="body-1 pa-2">
            <template v-for="(body,index) in item.body">
              <div class="body-1 pa-2" v-if="body.type=='plain'" :key="index">{{body.data}}</div>
              <div class="body-1 pa-2" v-if="body.type=='list'" :key="index">
                <ul>
                  <li v-for="(bullet,index) in body.data" :key="index">{{bullet}}</li>
                </ul>
              </div>
              <div class="pa-5 row justify-center" v-if="body.type=='image'" :key="index">
                <img :src="body.data" style="max-height:400px" />
              </div>
              <div class="pa-2 row justify-center" v-if="body.type=='video'" :key="index">
                <video
                  class="video-js"
                  controls
                  preload="auto"
                  width="640"
                  :poster="body.data.poster"
                  data-setup="{}"
                >
                  <source :src="body.data.mp4" type="video/mp4" />
                  <source :src="body.data.webm" type="video/webm" />
                  <source :src="body.data.ogv" type="video/ogg" />
                  <p class="vjs-no-js">
                    To view this video please enable JavaScript, and consider upgrading to a
                    web browser that
                    <a
                      href="https://videojs.com/html5-video-support/"
                      target="_blank"
                    >supports HTML5 video</a>
                  </p>
                </video>
              </div>
              <div class="pa-5 row justify-center" v-if="body.type=='html'" :key="index">
                <div v-html="body.data"></div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AHelpItem",
  props: ["data"]
};
</script>